<style lang="less" scoped>
  .demo-split{
    border: 1px solid #dcdee2;
    position:relative;
  }
  .demo-split-pane{
    overflow: auto;
    padding: 10px;
  }
  .demo-split-pane-r{
    padding: 10px 10px 10px 16px;
  }
  .contain {
    height: 100%;
    display: flex;
    flex-direction: column;
    .detail {
      margin: 10px 0 10px;
      flex: 1;
      display: flex;
      flex-direction: row;
      .tree-card {
        flex: 2;
        margin-right: 10px;
      }
      .grop-card {
        flex:3;
      }
      .route-tree {
        padding: 0 !important;
        /deep/ ul {
          padding: 0;
        }
        /deep/ .title-p {

        }
      }
    }
  }
  .group-list-contain {
    padding: 10px;
    border: solid 1px #dcdee2;
    border-radius: 5px;
    .items {
      cursor: pointer;
    }
  }
  .name-contian {
    margin: 10px 0;
    .group-style {
      font-size: 10px;
      padding: 0 10px;
      color: #f90;
    }
  }
  /deep/.ivu-split-pane {
    overflow: auto;
  }
</style>
<template>
  <div class="contain">
    <Spin
      v-if="loading.getAppDetailLoading"
      size="large"
      fix
    />
    <!-- 头部标签 -->
    <Card>
      <p slot="title">
        {{ appDetail.name }}
      </p>
      <p>token：{{ appDetail.app_token }}</p>
      <p>
        网址：<a
          :href="`https://${appDetail.home_page}`"
          target="_blank"
        >{{ appDetail.home_page }}</a>
      </p>
      <p>
        备注：{{ appDetail.remark }}
      </p>
      <v-row no-gutters>
        <v-col
          cols="3"
        >
          <v-switch
            v-model="showApiAuth"
            style="margin-top: 0px"
            :label="`${showApiAuth ? '展示' : '隐藏'} API 权限`"
          />
        </v-col>
        <v-col
          cols="1"
          offset="7"
        >
          <v-btn
            :loading="loadingApiInit"
            :disabled="loadingApiInit"
            color="error"
            @click="initApiData"
          >
            初始化API权限
          </v-btn>
        </v-col>
      </v-row>
    </Card>
    <div class="detail">
      <!-- 路由树 -->
      <Card class="tree-card">
        <p slot="title">
          路由详情
        </p>
        <div :style="{height:table_height,overflow:'auto'}">
          <TreeNew
            v-if="tree.length!==0"
            :tree-data="filteredTree"
            :could-checkout="false"
            :could-edit="true"
            :could-select="true"
            :could-grag="true"
            class="route-tree"
            @selectedChange="selectedChange"
            @addNewOne="addNewOne"
            @editOne="editOne"
            @startStop="editOne"
            @gragOk="gragOk"
          />
        </div>
      </Card>
      <Card class="grop-card">
        <p
          slot="title"
          style="height:24px"
        >
          权限成员
        </p>
        <div>
          <div
            class="demo-split"
            :style="{height:table_height}"
          >
            <Spin
              v-if="loading.jurisdictionLoading"
              size="large"
              fix
            />
            <Split
              v-model="split1"
              :min="'400px'"
            >
              <div
                slot="left"
                class="demo-split-pane"
              >
                <div style="margin:10px 0">
                  <h3 style="margin:10px 0;display:inline">
                    群组详情
                  </h3>
                  <span style="float:right">
                    <Button
                      v-show="!showBindJurisdictionState"
                      size="small"
                      type="primary"
                      :disabled="!jurisdictionItemSelected"
                      @click="changeBindJurisdictionState"
                    >权限编辑</Button>
                    <span v-show="showBindJurisdictionState">
                      <Button
                        style="margin-right:10px"
                        size="small"
                        @click="cancelSelect"
                      >取消</Button>
                      <Button
                        size="small"
                        type="primary"
                        :loading="loading.editJurisdictionLoading"
                        @click="submitSelect(1)"
                      >保存</Button>
                    </span>
                  </span>
                </div>
                <div
                  v-show="showBindJurisdictionState"
                  class="group-list-contain"
                  style="margin:10px 0;"
                >
                  <CheckboxGroup
                    v-model="selectedBox"
                    @on-change="changeSelectedBox"
                  >
                    <Checkbox
                      v-for="item in groupList"
                      :key="item.id"
                      :label="item.id"
                      :disabled="item.del"
                    >
                      <span>{{ `${item.name}/${item.group_key}` }}</span>
                    </Checkbox>
                  </CheckboxGroup>
                </div>
                <Collapse v-show="jurisdictionGroups.length">
                  <Panel
                    v-for="item in jurisdictionGroups"
                    :key="item.group_key"
                    :name="item.group_key"
                  >
                    {{ `${item.name}/${item.group_key}` }}
                    <div slot="content">
                      <p>组名：{{ item.name }}</p>
                      <p>group_key：{{ item.group_key }}</p>
                      <div style="margin:10px 0">
                        <h4>成员</h4>
                        <div style="margin:10px 0">
                          <Button
                            v-show="!item.customers"
                            size="small"
                            type="text"
                            @click="checkCustomers(item)"
                          >
                            点击查看详情
                          </Button>
                          <Tag
                            v-for="child in item.customers||[]"
                            :key="child.id"
                            size="medium"
                          >
                            {{ child.account }}
                          </Tag>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              </div>
              <div
                slot="right"
                class="demo-split-pane-r"
              >
                <div style="margin:10px 0;">
                  <h3 style="margin:10px 0;display:inline">
                    个人权限
                  </h3>
                  <span style="float:right">
                    <Button
                      v-show="!showBindJurisdictionPerson"
                      size="small"
                      type="primary"
                      :disabled="!jurisdictionItemSelected"
                      @click="changeShowBindJurisdictionPerson"
                    >权限编辑</Button>
                    <span v-show="showBindJurisdictionPerson">
                      <Button
                        style="margin-right:10px"
                        size="small"
                        @click="cancelSelectPerson"
                      >取消</Button>
                      <Button
                        size="small"
                        type="primary"
                        :loading="loading.editJurisdictionLoading"
                        @click="submitSelect(2)"
                      >保存</Button>
                    </span>
                  </span>
                </div>
                <div style="margin:10px 0">
                  <Selector
                    v-show="showBindJurisdictionPerson"
                    :transfer="true"
                    style="width:300px"
                    @on-change="selectedPerson"
                  />
                  <div class="name-contian">
                    <span
                      v-for="(child,index) in jurisdictionPersons||[]"
                      :key="child.id"
                      style="margin-right:10px"
                    >
                      <Tag
                        size="medium"
                        :closable="showBindJurisdictionPerson"
                        @on-close="delSelectedPerson(index)"
                      >
                        {{ child.account }}
                        <span
                          v-show="showBindJurisdictionPerson&&!!personIncludedGroup[child.id]"
                          class="group-style"
                        >
                          已存在于 [{{ personIncludedGroup[child.id]&&personIncludedGroup[child.id].join('，') }}]
                        </span>
                      </Tag>
                    </span>
                  </div>
                </div>
              </div>
            </Split>
          </div>
        </div>
      </Card>
    </div>
    <RouterEditModal
      :loading="loading.routerSubmitLoading"
      :form-props="selectedRouterItem"
      :display="showRouterEditModal"
      :source-data="tree"
      @ok="submitData"
      @cancel="showRouterEditModal = 0"
    />
    <StartStopModal
      :loading="loading.routerSubmitLoading"
      :display="showStartStopModal"
      :form-props="selectedRouterItem"
      @ok="submitData"
      @cancel="showStartStopModal = false"
    />
  </div>
</template>
<script route="/router_manage/edit/app_router_manage">
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { ROUTER_MANAGE_EDIT } from '../constants'
  import { twoArrInlcudeNode } from '../../utils'
  import TreeNew from '../../components/TreeNew'
  import RouterEditModal from './../components/RouterEditModal'
  import StartStopModal from '../../components/StartStopModal'
  import Selector from './../../../components/customer/selector'
  import apiConig from '../../../../api'
  export default {
    components:{ TreeNew, RouterEditModal, StartStopModal, Selector },
    data() {
      this.oldSelect = []
      this.oldPerson = []
      this.index = 0
      return {
        id: null,
        split1:0.6,
        showBindJurisdictionState:false,
        showBindJurisdictionPerson:false,
        selectedBox:[],
        personIncludedGroup: {},
        selectedRouterItem: {},
        showStartStopModal: false,
        showRouterEditModal: 0, // 新增 1 编辑 2 更新路由
        showApiAuth: false,
        loadingApiInit: false,
      }
    },
    computed:{
      ...mapState(ROUTER_MANAGE_EDIT, {
        loading:'loading',
        appDetail:'appDetail',
        tree: 'tree',
        jurisdictionGroups:'jurisdictionGroups',
        jurisdictionPersons:'jurisdictionPersons',
        jurisdictionItemSelected:'jurisdictionItemSelected',
        groupList:'groupList',
        groupDict:'groupDict'
      }),
      table_height() {
        const window_height = this.$store.state.window_height;
        return (window_height - 400) + 'px';
      },
      filteredTree() {
        if (this.showApiAuth) {
          return this.tree;
        }
        // 过滤所有的 API 节点
        const dfs = (node) => {
          // console.log(node)
          if (Array.isArray(node.items) && node.items.length > 0) {
            node.items = node.items.slice().filter((item) => {
              return item.route_type !== 'api'
            })
            node.items.forEach(item => dfs(item))
          }
          return node
        }
        const tree = JSON.parse(JSON.stringify(this.tree))
        const res = dfs(tree[0])
        return [res]
      }
    },
    mounted() {
      this.id = this.$router.currentRoute.query.id
      this.getAppDetail({ id:this.id })
      this.getGroupList()
    },
    destroyed() {
      this.initData()
    },
    methods:{
      ...mapActions(ROUTER_MANAGE_EDIT, ['getAppDetail', 'updateRouter', 'getJurisdictionDetail', 'getGroupList', 'editGroupJurisdiction', 'getGroupCustomers', 'dragNode']),
      ...mapMutations(ROUTER_MANAGE_EDIT, {
        setStateLevel0: 'setStateLevel0',
        initData:'initData'
      }),
      async initApiData() {
        this.loadingApiInit = true;
        await apiConig.initApi()
        this.loadingApiInit = false;
      },
      /* 新增路由 点击新增路由按钮*/
      addNewOne(data) {
        this.closePersonAndGroup()
        let dataclone = {key:''}
        dataclone.parent_name = data.name
        dataclone.parent_id = data.level === 0 ? 0 : data.id
        dataclone.parent_key = data.auth_key
        dataclone = {...data, ...dataclone}
        this.showRouterEditModal = 1
        this.selectedRouterItem = dataclone
      },
      /* 编辑路由｜禁用路由 点击编辑路由按钮*/
      editOne(level, oldParent, child, isDel) {
        this.closePersonAndGroup()
        // eslint-disable-next-line
        const { created_at, items, sort_order, updated_at, pinyin,...other} = child
        const parent_id = level <= 1 ? 0 : oldParent.id
        const dataClone = {
          ...other,
          parent_key:oldParent.auth_key,
          parent_id,
          parent_name:oldParent.name,
        }
        if (isDel) {
          this.showStartStopModal = true
        } else {
          this.showRouterEditModal = 2
        }
        this.selectedRouterItem = dataClone
      },
      /* 提交编辑｜禁用 弹窗数据 */
      submitData(data) {
        const _this = this
        const {
          name,
          parent_id = 0,
          auth_key,
          id,
          pinyin,
          icon,
          route_type,
          path,
          red_dot_token,
          pb_workspace_id,
          pb_report_id,
          is_public,
          is_formal,
          is_team_leader,
          del = false
        } = data
        const params = {
          name,
          auth_key,
          parent_id,
          pinyin,
          icon,
          route_type,
          path,
          red_dot_token,
          pb_workspace_id,
          pb_report_id,
          is_public,
          is_formal,
          is_team_leader,
          del: del || false
        }
        if (this.showRouterEditModal === 2 || _this.showStartStopModal) { // 编辑
          params.id = id
        }
        this.updateRouter({params, callBack() {
          if (_this.showStartStopModal) {
            _this.$Message.success(`${del ? '禁止' : '启用'}成功`)
            _this.showStartStopModal = false
            return
          }
          _this.showRouterEditModal = 0
          _this.$Message.success(`${_this.showRouterEditModal === 1 ? '新增' : '编辑'}成功`)
        }})
      },
      /* 选中路由树的条目 */
      selectedChange(data) {
        if (this.jurisdictionItemSelected && this.jurisdictionItemSelected.id === data.id) {
          return
        }
        this.closePersonAndGroup()
        this.getJurisdictionDetail({params:data})
      },
      /* 编辑组群状态开启 */
      changeBindJurisdictionState() {
        this.closePersonAndGroup()
        this.showBindJurisdictionState = true
        this.oldSelect = [...(this.jurisdictionGroups || [])] // 保存状态
        this.selectedBox = (this.jurisdictionGroups || []).map(item => item.id)
      },
      changeShowBindJurisdictionPerson() {
        this.closePersonAndGroup()
        const obj = {}
        this.jurisdictionGroups.forEach(item => {
          if (item.customers) {
            item.customers.forEach(person => {
              if (!obj[person.id]) {
                obj[person.id] = []
              }
              obj[person.id].push(`${item.name}/${item.group_key}`)
            })
          }
        });
        this.personIncludedGroup = obj
        this.showBindJurisdictionPerson = true
        this.oldPerson = [...this.jurisdictionPersons]
      },
      delSelectedPerson(index) {// hack
        this.jurisdictionPersons.splice(index, 1)
      },
      selectedPerson(data) {
        if (this.jurisdictionPersons.some(item => item.id === data.id)) {
          this.$Message.warning('列表中已存在此人')
          return
        }
        // hack
        this.jurisdictionPersons.push(data)
      },
      closePersonAndGroup() {
        if (this.showBindJurisdictionPerson) {
          this.cancelSelectPerson()
        }
        if (this.showBindJurisdictionState) {
          this.cancelSelect()
        }
      },
      cancelSelectPerson() {
        this.showBindJurisdictionPerson = false
        this.setStateLevel0({ key:'jurisdictionPersons', value:[...this.oldPerson] })
      },
      cancelSelect() {
        this.showBindJurisdictionState = false
        // this.jurisdictionGroups = [...this.oldSelect]
        this.setStateLevel0({ key:'jurisdictionGroups', value:[...this.oldSelect] })
      },
      changeSelectedBox() {
        const data = this.selectedBox.map(id => this.groupDict[id])
        // this.jurisdictionGroups = data
        this.setStateLevel0({ key:'jurisdictionGroups', value:data })
      },
      submitSelect(type) { // 群组保存便过后的权限
        const jurisdictionGroupsClone = this.jurisdictionGroups || []
        const jurisdictionPersonsClone = this.jurisdictionPersons || []
        const oldSelectClone = this.oldSelect || []
        const oldSelectPersonClone = this.oldPerson || []
        let add_group_ids = []
        let del_group_ids = []
        let	add_customer_ids = []
        let del_customer_ids = []
        const _this = this
        if (type === 1) {
          // result[0] 表示 params[0]中有的条目且params[1]中没有的条目
          // result[1] 表示 params[1]中有的条目且params[0]中没有的条目
          const result = twoArrInlcudeNode(jurisdictionGroupsClone, oldSelectClone)
          del_group_ids = result[1]
          add_group_ids = result[0]
        } else {
          const result = twoArrInlcudeNode(jurisdictionPersonsClone, oldSelectPersonClone)
          del_customer_ids = result[1]
          add_customer_ids = result[0]
        }
        this.editGroupJurisdiction({
          id:this.jurisdictionItemSelected.id,
          del_group_ids,
          add_group_ids,
          add_customer_ids,
          del_customer_ids,
          callBack() {
            _this.$Message.success('权限编辑成功')
            if (type === 1) {
              _this.showBindJurisdictionState = false
            } else {
              _this.showBindJurisdictionPerson = false
            }
          }
        })
      },
      checkCustomers(data) {
        this.getGroupCustomers(data)
      },
      gragOk(data) {
        const _this = this
        this.dragNode({...data, callBack(name) {
          _this.$Message.success(`成功更新节点[${name}]位置`)
        }})
      },
    },
  }
</script>
r
